// @flow
import * as React from 'react';
import { Pagination } from '@components';
import { trackWindowScroll } from 'react-lazy-load-image-component';
import { StyledVerticalSpacer } from '@components/Wrappers/styles/index';
import ArticlesListCard from './components/Card';
import type { Props } from './types';
import type { Article } from '../../types';

const ArticlesList = ({
  articles,
  currentPage,
  numberOfPages,
  setPage,
  pathname,
  scrollPosition
}: Props): React.Node => (
  <>
    {articles.map((article: Article): React.Node => (
      <ArticlesListCard
        id={article.attributes.id}
        scrollPosition={scrollPosition}
        key={article.attributes.id}
        slug={article.attributes.slug}
        title={article.attributes.title}
        date={new Date(article.attributes.published_at)}
        image={article.attributes.listing_image?.url || article.attributes.cover_image.url}
        lead={article.attributes.article_summary}
      />
    ))}
    {typeof numberOfPages !== 'undefined' && numberOfPages > 1 && (
      <Pagination
        pathname={pathname}
        initialPage={currentPage - 1}
        numberOfPages={numberOfPages}
        setPage={setPage}
      />
    )}

    <StyledVerticalSpacer />
  </>
);

export default trackWindowScroll(ArticlesList);
